"use strict";
//  Application.ts
//
//  Opera House | Typescript - Model Class
//  Updated 2020-02-14
//  Copyright © 2020 Apptivity Lab. All rights reserved.
//
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const ObjectModel_1 = require("../ObjectModel");
class Application extends ObjectModel_1.OMObject {
    constructor(object) {
        super(object);
        this.environment = object.environment;
        this.uriScheme = object.uriScheme;
        this.applicationKey = object.applicationKey;
        this.uriHost = object.uriHost;
        this.identifier = object.identifier;
        this.buildNumber = object.buildNumber;
        this.platform = object.platform;
        this.version = object.version;
        this.snsArn = object.snsArn;
        // tslint:disable-next-line
        this.installation = object.installation ? object.installation.map((item) => new __1.OMReference(__1.Installation, item)) : [];
    }
}
Application.Type = "application";
Application.Path = "applications";
exports.default = Application;
//# sourceMappingURL=Application.js.map